/**
 * Description:
 * Customizes the webstore 
 * Lead registration form.

 * Anthony Dittus
 * November 11, 2020
 */

define(
	'LeadRegistrationFormReconfig'
	, [
		'LoginRegister.Register.View',
		'underscore'
	]
	, function (
		LoginRegisterRegisterView,
		_
	) {
		'use strict';

		return {

			mountToApp: function mountToApp(container) {
				//*console.log('Lead Registration Form Reconfig EXT: INITIATED');


				_.extend(LoginRegisterRegisterView.prototype, {
					initialize: _.extend(LoginRegisterRegisterView.prototype.initialize, function (options) {
						$('.login-register-register-form').one('submit', function () {
							$('#submission-button').attr('disabled', 'true');
						});
						//$('#relay-button').attr('onclick', "$('#relay-button').disabled = true;");
					})
				});

				_.extend(LoginRegisterRegisterView.prototype, {
					events: _.extend(LoginRegisterRegisterView.prototype.events, {
						'change [data-action="reconfigure-phone-to-text"]': 'reconfigurePhoneToText',
						'change [data-action="reconfigure-state-to-text"]': 'reconfigureStateToText',
						'change [data-action="reconfigure-country-to-text"]': 'reconfigureCountryToText',
						//'focusout [data-action="reconfigure-country-to-text"]': 'validateRequiredCustomFieldOnMouseOut',
						//'submit [data-action="reconfigure-country-to-text"]': 'validateRequiredCustomFieldOnSubmit',
						'click [data-action="submission-relay"]': 'submissionRelay'
					})

					, reconfigurePhoneToText: function () {
						var phoneVal = $('#phone').val();
						//*console.log('phoneVal: ', phoneVal);

						var phoneNumberDigitLength = JSON.stringify(phoneVal).replace(/[^0-9]/g, "").length

						//*console.log('phoneNumberDigitLength: ', phoneNumberDigitLength);


						if (phoneNumberDigitLength >= 7) {
							$('#custentity_registration_company_phone').val(phoneVal);

							$('#phone').attr('style', '');
							$('#phone-validation-rejection-msg').css('display', 'none');

						} else {
							$('#phone').attr('style', 'border-color:#c01a29;outline-color:#C47279;width:auto;min-width:300px;display:block;padding:10px;color:#404040;font-size:1rem;margin-bottom:10px;line-height:normal;');
							$('#phone-validation-rejection-msg').css('display', 'inline-block');
						}
					}

					, reconfigureStateToText: function () {
						var stateVal = $('select#state option:checked').val();
						//*console.log('stateVal: ', stateVal);
						$('#custentity_registration_state').val(stateVal);
					}



					, reconfigureCountryToText: function () {
						var countryVal = $('select#country option:checked').val();
						//*console.log('countryVal: ', countryVal);
						$('#custentity_registration_country').val(countryVal);

						if (countryVal == '') {
							$('#country').attr('style', 'border-color:#c01a29;outline-color:#C47279;width:auto;min-width:300px;display:block;padding:10px;color:#404040;font-size:1rem;margin-bottom:10px;line-height:normal;');
							$('#validation-rejection-msg').css('display', 'inline-block');

						} else {
							$('#country').attr('style', '');
							$('#validation-rejection-msg').css('display', 'none');
							//$('.login-register-register-form-submit').attr('disabled', false);
						}
					}
					, submissionRelay: _.debounce(function (e) {
						console.log('[Recaptcha] submissionRelay triggered');

						e.preventDefault();

						var alertContainer = $('.login-register-register-form-messages');
						var $form = $('form.login-register-register-form');
						var $submitButton = $('#submission-button');

                        // One-shot guard to prevent re-entry during form submit
                        if (window.__registerSubmitting) {
                            console.log('[Recaptcha] submission ignored (already submitting)');
                            return false;
                        }
                        // Disable button early to prevent double-clicks
                        $submitButton.attr('disabled', true);
                        setTimeout(function(){ if ($submitButton && $submitButton.length) $submitButton.attr('disabled', false); }, 1200);

                        // Short-lived lock to prevent rapid double-clicks (does not block later retries)
                        var __clickLocked = true;
                        setTimeout(function(){ __clickLocked = false; }, 800);

						console.log('[Recaptcha] form element:', $form.length ? 'found' : 'not found');
						console.log('[Recaptcha] submit button element:', $submitButton.length ? 'found' : 'not found');

						// Check if reCAPTCHA is enabled via NetSuite configuration
						var recaptchaEnabled = window.RecaptchaIntegration && window.RecaptchaIntegration.isEnabled();
						console.log('[Recaptcha] Enabled via NetSuite config:', recaptchaEnabled);

						var lastResetTimestamp = 0;
						var resetRecaptchaSafely = function(reason) {
							if (!recaptchaEnabled) {
								return;
							}
							if (!(window.RecaptchaIntegration && typeof RecaptchaIntegration.resetRecaptcha === 'function')) {
								return;
							}
							var now = Date.now();
							if (lastResetTimestamp && now - lastResetTimestamp < 200) {
								return;
							}
							lastResetTimestamp = now;
							console.log('[Recaptcha] Resetting reCAPTCHA' + (reason ? ' - ' + reason : ''));
							RecaptchaIntegration.resetRecaptcha('register-recaptcha');
						};

                        // Observe for validation error messages and reset reCAPTCHA so the user sees a fresh box
                        try {
                            var __msg = document.querySelector('.login-register-register-form-messages');
                            if (__msg && !__msg.__recaptchaObserverAttached) {
								var __obs = new MutationObserver(function(muts){
									var shouldReset = false;
									muts.forEach(function(m){
										if (m.addedNodes && m.addedNodes.length) {
											shouldReset = true;
										}
									});
									if (shouldReset) {
										resetRecaptchaSafely('error message added');
									}
								});
								__obs.observe(__msg, { childList: true, subtree: true });
                                __msg.__recaptchaObserverAttached = true;
                            }

							var __form = document.querySelector('form.login-register-register-form');
							if (__form && !__form.__recaptchaValidationObserverAttached) {
								var __formObserver = new MutationObserver(function(muts){
									var shouldReset = false;
									muts.forEach(function(m){
										if (m.type === 'childList') {
											m.addedNodes.forEach(function(node){
												if (node.nodeType !== 1) {
													return;
												}
												if (node.getAttribute && (node.getAttribute('data-validation-error') !== null || node.getAttribute('aria-invalid') === 'true')) {
													shouldReset = true;
													return;
												}
												if (node.querySelector && (node.querySelector('[data-validation-error]') || node.querySelector('[aria-invalid="true"]'))) {
													shouldReset = true;
												}
											});
										} else if (m.type === 'attributes') {
											var attrTarget = m.target;
											if (!attrTarget || typeof attrTarget.getAttribute !== 'function') {
												return;
											}
											if (attrTarget.getAttribute('aria-invalid') === 'true') {
												shouldReset = true;
											}
											if (attrTarget.getAttribute('data-validation-error') !== null) {
												shouldReset = true;
											}
										}
									});

									if (shouldReset) {
										resetRecaptchaSafely('field validation error');
									}
								});

								__formObserver.observe(__form, {
									childList: true,
									subtree: true,
									attributes: true,
									attributeFilter: ['aria-invalid', 'data-validation-error']
								});
								__form.__recaptchaValidationObserverAttached = true;
							}
                        } catch(e) { console.warn('[Recaptcha] observer setup failed:', e); }


						// Only validate reCAPTCHA if it's enabled
						if (recaptchaEnabled) {
							// Ensure the widget is present before trying to get response
							// This handles cases where the widget may have been cleared
							if (window.RecaptchaIntegration && window.RecaptchaIntegration.addRecaptchaToRegister) {
								window.RecaptchaIntegration.addRecaptchaToRegister();
							}
							// Get reCAPTCHA response specifically for the registration widget
                            // Get reCAPTCHA response using safe helper
                            var recaptchaResponse = '';
                            try {
                                if (window.RecaptchaIntegration && typeof RecaptchaIntegration.getRecaptchaResponse === 'function') {
                                    recaptchaResponse = RecaptchaIntegration.getRecaptchaResponse('register-recaptcha');
                                } else {
                                    console.warn('[Recaptcha] RecaptchaIntegration.getRecaptchaResponse not available');
                                }
                            } catch (err) {
                                console.warn('[Recaptcha] Error getting safe response:', err);
                                recaptchaResponse = '';
                            }
                            console.log('[Recaptcha] recaptchaResponse:', recaptchaResponse ? recaptchaResponse : '(empty)');

							// Show error if not completed
							if (!recaptchaResponse) {
								console.warn('[Recaptcha] reCAPTCHA not completed');
								if (alertContainer.length) {
									alertContainer.html(
										'<div class="alert alert-error" role="alert" style="background-color:#fdf0f2;border:1px solid #c01a29;color:#c01a29;padding:10px;margin:10px 0;">' +
										'<strong>Please complete the reCAPTCHA verification before registering.</strong>' +
										'</div>'
									);
                            		$submitButton.attr('disabled', false); // re-enable if we block
								}
								return false;
							}

							// Clear old messages
							if (alertContainer.length) {
								alertContainer.html('');
							}

							console.log('[Recaptcha] Adding hidden g-recaptcha-response field to form');
							// Inject reCAPTCHA token into the form
							$form.find('[name="g-recaptcha-response"]').remove();
							$form.append(
								$('<input>')
									.attr('type', 'hidden')
									.attr('name', 'g-recaptcha-response')
									.val(recaptchaResponse)
							);
						} else {
							console.log('[Recaptcha] reCAPTCHA is disabled - skipping validation');
							// Clear any old reCAPTCHA error messages
							if (alertContainer.length) {
								alertContainer.html('');
							}
						}

						console.log('[Recaptcha] Attempting form submission...');

						// Disable button to prevent double-clicks

						// Trigger the actual form submit
						console.log('[Recaptcha] Submitting form directly...');
						$form.trigger('submit');

						setTimeout(function(){
							if (!$form || !$form.length) {
								return;
							}
							var inlineErrors = $form.find('[data-validation-error]').length || $form.find('[aria-invalid="true"]').length;
							var alertHasContent = alertContainer.length && alertContainer.text().trim().length;
							if (inlineErrors || alertHasContent) {
								resetRecaptchaSafely('detected validation errors after submit');
							}
						}, 350);

						return true;
					}, 500)



					// , validateRequiredCustomFieldOnMouseOut: function () {
					// 	var countryVal = $('#custentity_registration_country').val();
					// 	console.log('countryVal: ', countryVal);
					// 	if (countryVal == '') {
					// 		$('#custentity_registration_country').attr('style', 'border-color:#c01a29;outline-color:#C47279;width:auto;min-width:300px;display:block;padding:10px;color:#404040;font-size:1rem;margin-bottom:10px;line-height:normal;');
					// 		$('#validation-rejection-msg').css('display', 'inline-block');

					// 	} else {
					// 		$('#custentity_registration_country').attr('style', '');
					// 		$('#validation-rejection-msg').css('display', 'none');
					// 	}
					// }
					// , validateRequiredCustomFieldOnSubmit: function () {
					// 	var countryValHiddenForm = $('custentity_registration_country').val();
					// 	if (countryValHiddenForm == '') {
					// 		$(".login-register-register-form").submit(function (e) {
					// 			e.preventDefault(e);
					// 		});

					// 		$('#country').attr('style', 'border-color:#c01a29;outline-color:#C47279;width:auto;min-width:300px;display:block;padding:10px;color:#404040;font-size:1rem;margin-bottom:10px;line-height:normal;');
					// 		$('#validation-rejection-msg').css('display', 'inline-block');
					// 		$('#country').focus();
					// 		//$('.login-register-register-form-submit').attr('disabled', true);

					// 	}
					// }

				});


				LoginRegisterRegisterView.prototype.redirect = function (context, response) {
					//*console.log('context, response: ', context, response);
					window.location.href = "https://www.broadfield.com/register-submit";
				}

			}
		};
	});
